module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Library-556450e562caf204711c0e26f82bfd8f.png";